import { handleResponseV2, makeGet } from '@/redux/api/helpers';
import { HouseBillingHistoryItem } from '@/redux/modules/billingManagement/houseBillingHistory/houseBillingHistory.types';

type GetHouseBillingHistoryParams = {
    authToken: string;
    deployment: string;
    houseId: number;
};

type GetHouseBillingHistoryResponse = {
    error: boolean;
    payload: HouseBillingHistoryItem[];
};

export const getHouseBillingHistory = ({ authToken, deployment, houseId }: GetHouseBillingHistoryParams) =>
    new Promise<GetHouseBillingHistoryResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: `admin/house/${houseId}/billing/items`,
            authToken,
            deployment,
            path: '<PAYMENT-SERVER-API>',
        });

        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
